// src/app/components/ui/GlassCard.tsx
import type { HTMLAttributes, ReactNode } from 'react';
import clsx from 'clsx';

interface GlassCardProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  /** Adds the hover-lift + glow interaction used across interactive cards. */
  interactive?: boolean;
  /** Removes inner padding for cards that manage their own layout (tables, charts). */
  noPadding?: boolean;
  className?: string;
}

/**
 * Shared glass-morphism surface used across the dashboard.
 * Matches the VaniaLabs ui-engine glass style: soft blur, hairline border,
 * low-opacity surface tint driven by theme tokens with sane fallbacks.
 */
export function GlassCard({
  children,
  interactive = false,
  noPadding = false,
  className,
  ...rest
}: GlassCardProps) {
  return (
    <div
      className={clsx(
        'vania-glass-card',
        interactive && 'vania-glass-card--interactive',
        !noPadding && 'p-5 sm:p-6',
        className,
      )}
      {...rest}
    >
      {children}
    </div>
  );
}
